export default (api, resource) => ({

    getGanhadores: async ({token,params})=>{
        const response = await api.get(`${resource}/ganhadores?`,{
            params, 
            headers:{
                Authorization : token
            }
        })

        return {
            data: response.data
        }
    },

    // Consulta pública, não envia token
    getGanhadoresPorSorteio: async ({id})=>{
        const response = await api.get(`${resource}/${id}/ganhadores`)

        return {
            data: response.data
        }
    },

    getAcumulados: async ({token,params})=>{
        const response = await api.get(`${resource}/acumulados?`,{
            params,
            headers:{
                Authorization : token
            }
        })

        return {
            data: response.data
        }
    }

})